"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var STATS_DEFAULT = {
  encryption: 'sha-256',
  audio: {
    send: {
      maxPacketLossRatio: 0,
      availableBandwidth: 0,
      bytesSent: 0,
      meanRemoteJitter: [],
      meanRoundTripTime: []
    },
    recv: {
      availableBandwidth: 0,
      bytesReceived: 0,
      meanRtpJitter: [],
      meanRoundTripTime: []
    }
  },
  video: {
    send: {
      maxPacketLossRatio: 0,
      availableBandwidth: 0,
      meanRemoteJitter: [],
      meanRoundTripTime: []
    },
    recv: {
      availableBandwidth: 0,
      totalPacketsLost: 0,
      meanRtpJitter: [],
      meanRoundTripTime: []
    },
    latency: 0,
    packetsLost: 0
  },
  share: {
    send: {
      maxPacketLossRatio: 0,
      availableBandwidth: 0,
      totalPacketsLost: 0,
      meanRemoteJitter: [],
      meanRoundTripTime: []
    },
    recv: {
      availableBandwidth: 0,
      meanRtpJitter: [],
      meanRoundTripTime: []
    },
    latency: 0,
    packetsLost: 0
  },
  bandwidth: {
    systemBandwidth: 0,
    sentPerSecond: 0,
    encodedPerSecond: 0,
    helper: {
      audioBytesSent: 0,
      videoBytestSent: 0
    },
    speed: 0
  },
  results: {},
  connectionType: {
    systemNetworkType: 'unknown',
    systemIpAddress: '0.0.0.0',
    local: {
      candidateType: [],
      transport: [],
      ipAddress: [],
      networkType: []
    },
    remote: {
      candidateType: [],
      transport: [],
      ipAddress: [],
      networkType: []
    }
  },
  resolutions: {
    video: {
      send: {
        width: 0,
        height: 0,
        framesSent: 0
      },
      recv: {
        width: 0,
        height: 0
      }
    },
    share: {
      send: {
        width: 0,
        height: 0,
        framesSent: 0
      },
      recv: {
        width: 0,
        height: 0
      }
    }
  },
  internal: {
    audio: {
      send: {},
      recv: {}
    },
    video: {
      send: {},
      recv: {}
    },
    share: {
      send: {},
      recv: {}
    },
    remote: {},
    candidates: {}
  }
};
var _default = STATS_DEFAULT;
exports.default = _default;
//# sourceMappingURL=global.js.map
